import React, {Component} from 'react';
import PropTypes from "prop-types";
import Api from "../../utils/Api";
import StaticFunctions from "../../utils/StaticFunctions";
import TableContainer from "../../utils/TableContainer";
import SearchField from "../../utils/SearchField";
import Timeformat from "../../utils/Timeformat";
import LoadingSplash from "../../globalComponents/LoadingSplash";

class OperatorOverviewContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        currentCompany: PropTypes.object.isRequired,
        changeView: PropTypes.func.isRequired,
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.state = {
            currentCompany: (this.props.baseData.companies && this.props.baseData.companies.currentCompany) ? this.props.baseData.companies.currentCompany : null,
            currentCompanyOperators: null,
            filteredCompanyOperators: null,
        };

        this.translate = this.props.baseData.translate;
        this.userLanguage = this.props.baseData.userData.language;
        this.timeFormat = this.props.baseData.languages.getFormatByLanguage(this.userLanguage).datetime;

        this.requestCompanyOperators = this.requestCompanyOperators.bind(this);
        this.onSearchNew = this.onSearchNew.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onCancel = this.onCancel.bind(this);

    }

    componentDidMount() {

        this.requestCompanyOperators();

    }

    componentDidUpdate(prevProps) {

        if (prevProps.baseData.companies.currentCompany !== this.props.baseData.companies.currentCompany) {
            this.setState({
                currentCompany: (this.props.baseData.companies && this.props.baseData.companies.currentCompany) ? this.props.baseData.companies.currentCompany : null
            }, this.requestCompanyOperators);
        }

    }

    requestCompanyOperators() {

        if (!this.props.baseData.companies || this.props.baseData.companies.currentCompany === null || this.state.currentCompany === null) {
            return;
        }

        const params = {
            action: 'getCompanyOperatorOverview',
            currentCompanyId: this.props.baseData.companies.currentCompany.id,
            companyId: this.state.currentCompany.id
        };

        const callback = function(res) {
            if (res) {
                this.setState({
                    currentCompanyOperators: res,
                    filteredCompanyOperators: res,
                });
            }
        }.bind(this);

        this.api.request('AdminFunctions', params, callback, null);

    }

    onSearch(value) {

        const timezone = (this.props.baseData.companies && this.props.baseData.companies.currentCompany) ? this.props.baseData.companies.currentCompany.timezone : 'UTC';
        const userLanguage = this.props.baseData.userData.language;
        const searchFields = ['id_operator', 'operator_name', 'id_token', 'token_name'];
        const companyName = (this.props.baseData.companies && this.props.baseData.companies.currentCompany) ? this.props.baseData.companies.currentCompany.name : null;
        const rows = this.state.currentCompanyOperators;
        const filteredRows = [];

        rows.some(
            (row) => {
                let addToResult = false;
                let last_seen = (row.last_seen) ? Timeformat.fromUnix(row.last_seen).getFormatedDate(this.timeFormat, timezone) : '';
                let date_start = (row.valid_until) ? Timeformat.fromUnix(row.date_start).getFormatedDate(this.timeFormat, timezone) : '';
                let date_end = (row.valid_until) ? Timeformat.fromUnix(row.date_end).getFormatedDate(this.timeFormat, timezone) : '';
                let last_modified = (row.modified) ? Timeformat.fromUnix(row.modified).getFormatedDate(this.timeFormat, timezone) : '';
                let date_created = (row.date_created) ? Timeformat.fromUnix(row.date_created).getFormatedDate(this.timeFormat, timezone) : '';
                let date_deleted = (row.date_deleted) ? Timeformat.fromUnix(row.date_deleted).getFormatedDate(this.timeFormat, timezone) : '';

                if (companyName && StaticFunctions.substringExists(companyName, value)) {
                    addToResult = true;
                } else if (last_seen && StaticFunctions.substringExists(last_seen, value)) {
                    addToResult = true;
                } else if (date_start && StaticFunctions.substringExists(date_start, value)) {
                    addToResult = true;
                } else if (date_end && StaticFunctions.substringExists(date_end, value)) {
                    addToResult = true;
                } else if (last_modified && StaticFunctions.substringExists(last_modified, value)) {
                    addToResult = true;
                } else if (date_created && StaticFunctions.substringExists(date_created, value)) {
                    addToResult = true;
                } else if (date_deleted && StaticFunctions.substringExists(date_deleted, value)) {
                    addToResult = true;
                } else {
                    searchFields.forEach(
                        (searchField) => {
                            if (row[searchField] && StaticFunctions.substringExists(row[searchField], value)) addToResult = true;
                        }
                    );
                }

                if (addToResult) filteredRows.push(row);
            }
        );

        this.setState({
            filteredCompanyOperators: filteredRows
        });

    }

    onCancel() {

        this.setState({
            filteredCompanyOperators: this.state.currentCompanyOperators,
        });

    }

    operatorEdit(operator) {

        this.changeView('edit', operator);

    }

    changeView(view, operator = null) {

        if (this.props.changeView) this.props.changeView(view, operator);

    }

    onSearchNew() {

    }

    getCompanyOperatorColumns() {

        const columns = [];

        if (this.props.baseData.checkUserRole('superadmin')) {
            columns.push({
                key: 'id',
                nameKey: 'id',
                sortType: 'int',
            });
        }

        columns.push(
            {
                key: 'name',
                nameKey: 'name',
                sortType: 'string',
            },
            {
                key: 'token',
                nameKey: 'token',
                sortType: 'string',
            },
            {
                key: 'tokenName',
                nameKey: 'tokenName',
                sortType: 'string',
            },
            {
                key: 'dateStartToken',
                nameKey: 'tokenValidFrom',
                sortType: 'datetime',
            },
            {
                key: 'dateEndToken',
                nameKey: 'tokenValidTill',
                sortType: 'datetime',
            },
            {
                key: 'dateCreated',
                nameKey: 'dateCreated',
                sortType: 'datetime',
            },
            {
                key: 'dateDeleted',
                nameKey: 'dateDeleted',
                sortType: 'datetime',
            },
            {
                key: 'lastUpdate',
                nameKey: 'lastUpdate',
                sortType: 'datetime',
            },
            {
                key: 'options',
                nameKey: 'options',
            }
        );

        return columns;

    }

    getCompanyOperatorRows() {

        const timezone = this.props.baseData.companies.currentCompany.timezone;
        const data = (this.state.filteredCompanyOperators) ? this.state.filteredCompanyOperators : [];
        const companyName = this.props.baseData.companies.currentCompany.name;
        const rows = [];

        for (let i = 0; i < data.length; i++) {
            let rowTemp = data[i];
            let dateStartToken = (rowTemp.date_start) ? Timeformat.fromUnix(rowTemp.date_start).getFormatedDate(this.timeFormat, timezone) : '-';
            let dateEndToken = (rowTemp.date_end) ? Timeformat.fromUnix(rowTemp.date_end).getFormatedDate(this.timeFormat, timezone) : '-';
            let dateCreated = (rowTemp.date_created) ? Timeformat.fromUnix(rowTemp.date_created).getFormatedDate(this.timeFormat, timezone) : '-';
            let dateDeleted = (rowTemp.date_deleted) ? Timeformat.fromUnix(rowTemp.date_deleted).getFormatedDate(this.timeFormat, timezone) : '-';
            let lastUpdate = (rowTemp.modified) ? Timeformat.fromUnix(rowTemp.modified).getFormatedDate(this.timeFormat, timezone) : '-';

            rows.push({
                id: rowTemp.id_operator,
                company: companyName,
                name: rowTemp.operator_name,
                info: rowTemp.operator_info,
                token: rowTemp.id_token,
                tokenName: rowTemp.token_name,
                dateStartToken: dateStartToken,
                dateEndToken: dateEndToken,
                dateCreated: dateCreated,
                dateDeleted: dateDeleted,
                lastUpdate: lastUpdate,
                options: <div className="tableOptions">
                    <a className="optionEdit" onClick={() => this.operatorEdit(rowTemp)} title={this.translate('edit')}>&nbsp;</a>
                </div>,
            });
        }

        return rows;

    }

    render() {

        if (!this.state.currentCompanyOperators) return <LoadingSplash color={'dark'} />;

        const dataCount = (this.state.filteredCompanyOperators) ? this.state.filteredCompanyOperators.length : 0;
        const countText = this.translate('operator');
        const operatorColumns = this.getCompanyOperatorColumns();
        const operatorRows = this.getCompanyOperatorRows();

        return (
            <div>
                <div className="ma-bo-20 clearfix">
                    <div className="clearfix">
                        <nav>
                            <h1>{this.translate('selectOperator')}</h1>

                            <SearchField
                                baseData={this.props.baseData}
                                name="searchOperatorOverview"
                                placeholder={this.translate('searching')}
                                styles={{padding: 0}}
                                onSearch={this.onSearchNew}
                                onCancel={this.onCancel}
                            />
                        </nav>
                    </div>

                    <div className="clearfix">
                        <div className="fll">
                            <p>{dataCount} {countText} {this.translate('found')}.</p>
                        </div>

                        <div className="flr">
                            <div className="bottomLinks">
                                <a className="prewLink" onClick={(e) => this.changeView('add')}>{this.translate('addNewOperator')}</a>
                            </div>
                        </div>
                    </div>

                    <div className="clearfix">
                        <TableContainer
                            baseData={this.props.baseData}
                            columns={operatorColumns}
                            rows={operatorRows}
                            fillGaps="-"
                        />
                    </div>
                </div>

                <div className="bottomLinks clearfix">
                    <a className="prewLink" onClick={() => this.props.baseData.pageNavigation('admin')}>{this.translate('backToOverview')}</a>
                </div>
            </div>
        );

    }

}

export default OperatorOverviewContainer;
